export class ParseCanvasToBlobError extends Error {}
export class CompressImageError extends Error {}
